<template>
    <card shadow>
      <h5 class="h3 title">
        <span class="d-block mb-3">Pending Users</span>
      </h5>
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th class="text-right" v-if="showActions">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="pendingUser in pendingUsers" v-bind:key="pendingUser.id">
            <td>{{pendingUser.name}}</td>
            <td>{{pendingUser.email}}</td>
            <td class="td-actions text-right" v-if="showActions">
              <!--<button
                type="button"
                rel="tooltip"
                class="btn btn-danger btn-icon btn-sm"
                data-original-title
                @click="declinePendingUser(pendingUser)"
                title
              >
                <i class="ni ni-fat-remove pt-1"></i>
              </button>-->
              <button
                type="button"
                rel="tooltip"
                class="btn btn-success btn-icon btn-sm"
                data-original-title
                @click="acceptPendingUser(pendingUser)"
                title
              >
                <i class="ni ni-check-bold pt-1"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </card>
</template>

<script>
import firebase from "@/config/firebase.js";

export default {
  name: "pendinguserscard",
  data() {
    return {
      pendingUsers: []
    };
  },
  methods: {
    declinePendingUser(user) {
      console.log("TEST DECLINE " + user.id);

      firebase
        .firestore()
        .doc("organizations/" + this.orgId + "/pendingUsers/" + user.id)
        .delete()
        .then(function() {
          console.log(
            "Document successfully deleted from pending users collection!"
          );
        })
        .catch(function(error) {
          console.error("Error removing document: ", error);
        })
        .then(() => {
          location.reload();
        });
    },
    acceptPendingUser(user) {
      console.log("TEST ACCEPT " + user.id);

      var userData = user;
      userData["orgId"] = this.orgId;

      firebase
        .firestore()
        .doc("organizations/" + this.orgId + "/users/" + user.id)
        .set(userData)
        .then(function() {
          console.log("Document successfully added to users collection!");
        })
        .catch(function(error) {
          console.error("Error removing document: ", error);
        });

      firebase
        .firestore()
        .doc("organizations/" + this.orgId + "/roles/" + user.id)
        .set({})
        .then(function() {
          console.log("Document successfully added to roles collection!");
        })
        .catch(function(error) {
          console.error("Error removing document: ", error);
        });

      firebase
        .firestore()
        .doc("organizations/" + this.orgId + "/pendingUsers/" + user.id)
        .delete()
        .then(function() {
          console.log(
            "Document successfully deleted from pending users collection!"
          );
        })
        .catch(function(error) {
          console.error("Error removing document: ", error);
        })
        .then(() => {
          location.reload();
        });
    },
    getPendingUsers(orgId) {
      firebase
        .firestore()
        .collection("organizations/" + orgId + "/pendingUsers")
        .get()
        .then(querySnapshot => {
          const documents = querySnapshot.docs.map(doc => {
            const docData = doc.data();
            docData.id = doc.id;

            return docData;
          });

          this.pendingUsers = documents;
        });
    }
  },
  computed: {
    orgId() {
      return this.$store.state.usermain.curOrg.id;
    },
    showActions() {
      return true;
    }
  },
  mounted() {
    this.getPendingUsers(this.orgId);
  }
};
</script>

<style scoped>
</style>
